module.exports = __webpack_public_path__ + "img/overdue_light.9d6b5e5b.svg";